import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  fetchOneLiveChatProof,
  startOneLiveChat,
} from '@belong/integrations-belong-one-chat/utils';
import { useSupportChatProvider } from 'hooks/use-support-chat';
import { selectUser } from 'store/redux/user/selectors';

export function SupportChat() {
  const provider = useSupportChatProvider();
  const userId: string | undefined = useSelector(selectUser)?.userId;

  useEffect(() => {
    if (provider !== 'one') {
      return;
    }

    void startOneLiveChat(userId ? fetchOneLiveChatProof : undefined);
  }, [provider, userId]);

  return null;
}
